module.exports = __webpack_public_path__ + "static/lp-lk-img-1-ce272446cb4570e8bfb45dd4b3016ca8.png";